<template>
  <div>
    <div class="head">
      <div class="zuocelogo">
        <img style="max-width:100%;height:auto;object-fit:contain" src="../assets/home/zuocelogo.png" alt="">
      </div>
      <div class="caidan">
        <el-menu class="menu" :default-active="page" @select="handleOpen" mode="horizontal">
          <el-menu-item index="1">HOME</el-menu-item>
          <el-menu-item index="2">ABOUT</el-menu-item>
          <!-- <el-menu-item index="8">观众中心</el-menu-item> -->
          <el-menu-item index="3">EXHIBIT</el-menu-item>
          <el-menu-item index="4" @click="xspt">EXHIBITOR DIRECTORY</el-menu-item>
          <el-menu-item index="5">VISIT</el-menu-item>
          <el-menu-item index="6">WHAT’S ON</el-menu-item>

        </el-menu>
      </div>
      <div class="headleft">
        <!-- <a v-if="language === 'chinese_simplified'" href="javascript:translate.changeLanguage('english');" class="ignore">切换为英语</a>
        <a v-if="language === 'english'" href="javascript:translate.changeLanguage('chinese_simplified');" class="ignore">切换为中文</a> -->
        <div @click="langchange2()" class="ignore zywqh"><img style="width:20px;margin-right:2px" src="../assets/index/chinese.png" alt="">中文</div>
        <!-- <div><img src="../assets/home/sousuo.png" alt=""></div> -->
      </div>

    </div>
    <div class="cebl" v-if="false">
      <div @click="tqhd" class="cblbox">
        <img src="../assets/home/tongqihuodong.png" alt="">
        <div class="cblwz">Concurrent Activities</div>
      </div>
      <div @mouseenter="zsimg('1')" @mouseleave="zsimg()" class="cblbox">
        <img v-if="showimg==1" style="position: absolute;width:100px;right:65px;top:50px" src="../assets/home/20190911065538.png" alt="">
        <img src="../assets/home/guanzhuwomen.png" alt="">
        <div class="cblwz">Follow us</div>
      </div>
      <div @mouseenter="zsimg('2')" @mouseleave="zsimg()" class="cblbox">
        <img v-if="showimg==2" style="position: absolute;width:100px;right:65px;top:110px" src="../assets/home/zxzx.jpg" alt="">
        <img src="../assets/home/zaixianzixun.png" alt="">
        <div class="cblwz">Online Consultat</div>
      </div>
      <div class="backTop" @click="backTop">
        <img src="../assets/home/xiangshang.png" alt="">
      </div>

    </div>
    <Index @childFn="parentFn" v-if="page === '1'" />
    <Gyzh :data="pageNum" :nametitle="title" v-if="page === '2'" />
    <Xwzx v-if="page === '3'" />

    <Gzzxeng v-if="page === '5'" />
    <Lxwm v-if="page === '6'" />
    <Bottom @childFn="parentFnbot" />
  </div>

</template>

<script>
import Bottom from './bottomeng.vue'
import Gyzh from '../components/caidaneng/gyzh.vue'
import Index from '../components/indexeng.vue'
import Xwzx from '../components/caidaneng/xwzx.vue'
import Zszx from '../components/caidaneng/zszx.vue'
import Gzzxeng from '../components/caidaneng/gzzx.vue'
import Lxwm from '../components/caidaneng/lxwm.vue'

export default {
  name: 'Head',
  components: {
    Gyzh,
    Index,
    Xwzx,
    Bottom,
    Zszx,
    Gzzxeng,
    Lxwm

  },
  data () {
    return {
      page: '1',
      pageNum: '',
      title: '',
      scrollTop: 0,
      showimg: ''
    }
  },

  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  created () {

  },
  beforeDestroy () {

  },
  destroyed: function () {
    window.removeEventListener('scroll', this.scrollToTop)
  },

  methods: {

    langchange2 () {
      this.$router.replace({ name: 'Head' })
    },
    handleOpen (key) {
      if (key === '4') {
        this.page = '1'
      } else if (key === '8') {
        this.page = '1'
      } else {
        this.page = key
      }
      console.log(this.page)
      this.pageNum = ''
      this.title = ''
    },
    parentFn (params1, params2, params3) {
      this.page = params1
      this.pageNum = params2
      this.title = params3
      this.backTop()
    },
    parentFnbot (params1, params2, params3) {
      this.page = params1
      this.pageNum = params2
      this.title = params3

      this.backTop()
    },
    tqhd () {
      window.open('http://www.caepi.org.cn/cidepi/', '_blank')
    },
    gzzc () {
      window.open('https://service.ciec.com.cn/ciec_sw/modules/register/preRegm/92392/WEB/zh/n#', '_blank')
    },
    xspt () {
      this.$alert('This feature is under maintenance. Please stay tuned!', 'Notice', {
        confirmButtonText: 'OK',
        type: 'info',
        center: true
      })
    },
    backTop () {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
    zsimg (index) {
      this.showimg = index
    }

  }
}
</script>
<style scoped>
.cblbox {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px dashed #eee;
}
.backTop {
  /* height: 40px; */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  cursor: pointer;
}
.cblwz {
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}
.cebl {
  padding: 10px 5px;
  position: fixed;
  right: 5px;
  bottom: 40%;
  text-align: center;
  width: 50px;
  background-image: linear-gradient(180deg, #0f9c77 17%, #0c68a3 100%);
  border-radius: 4px 0px 0px 4px;
}
body {
  padding: 0;
  margin: 0 !important;
}
.menu {
  border: none !important;
}
.head {
  display: flex;
  height: 88px;
  justify-content: space-between;
  width: 100%;
}
.zuocelogo {
  flex: 1;
  width: 594px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.caidan {
  flex: 1.9;
  display: flex;
  justify-content: end;
  align-items: center; /* 垂直居中 */
}
.headleft {
  flex: 0.2;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: space-around;
  margin-left: 20px;
  cursor: pointer;
}
.el-menu-item {
  font-size: 16px;
  color: #475569;
  letter-spacing: 0;
  font-weight: 500;
}
.zywqh {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/headeng.vue